import React from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";
import Map from "./components/Map";
import Breadcrumbs from "./components/Breadcrumbs";
import Sidebar from "./components/Sidebar";
import usePolygons from "./hooks/usePolygons";
import { GadmFeature } from "./components/Map/types";
import { AppStore } from "../../redux/store";

const HeatMapHome: React.FC = () => {
  const country = useSelector((store: AppStore) => get(store, "country.country", "sv"));
  const { features, level, loading, data, trail, priceMin, priceMax, setPriceMin, setPriceMax, loadByParent, navigateToLevel } = usePolygons();

  const handleFeatureClick = (feature: GadmFeature) => {
    const parentId = get(feature, "properties.id") as number | undefined;
    const parentName = get(feature, `properties.NAME_${level}`) as string | undefined;
    if (parentId) loadByParent(parentId, level + 1, parentName);
  };

  return (
    <div className="w-full relative" style={{ height: "calc(100vh - 64px)" }}>
      {/* Mobile: Sidebar arriba (order-1), Breadcrumbs abajo (order-2)
          Web:    Breadcrumbs arriba (order-1), Sidebar abajo (order-2) */}
      {/* Mobile: Sidebar arriba (order-1), Breadcrumbs abajo (order-2)
          Web:    Breadcrumbs arriba full-width (order-1), Sidebar abajo izquierda (order-2) */}
      <div className="absolute z-20 top-4 left-0 right-0 md:top-0 flex flex-col pointer-events-none">
        <div className="order-2 md:order-1 w-full pointer-events-auto">
          <Breadcrumbs country={country} activeLevel={level} trail={trail} onNavigate={navigateToLevel} />
        </div>
        <Sidebar country={country} data={data} priceMin={priceMin ?? 0} priceMax={priceMax ?? 0} onPriceMinChange={setPriceMin} onPriceMaxChange={setPriceMax} onZoneSelect={(zone) => loadByParent(zone.id, level + 1, zone.name)} />
      </div>
      <Map features={features} loading={loading} onFeatureClick={handleFeatureClick} />
    </div>
  );
};

export default HeatMapHome;
